import {
  memo,
  useEffect,
  useRef,
  useState,
} from 'react';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

import Styles from './styles.module.scss';

const DIRECTIONS = {
  LEFT: 0x01,
  RIGHT: 0x02,
};

const cx = classNames.bind(Styles);
const HelpCenterTabs = ({ tabs, activeTab }) => {
  const [leftArrowHidden, setLeftArrowHidden] = useState(true);
  const [rightArrowHidden, setRightArrowHidden] = useState(true);
  const [navListStyles, setNavListStyles] = useState({ marginLeft: '0px' });

  const [mounted, setMounted] = useState(true);

  const width = useSelector((state) => state.common.width);
  const topicMain = useRef();
  const topicTab = useRef();
  const navList = useRef();

  let distanceBetween = 20;
  let scrolling = false;

  const onResize = () => {
    distanceBetween = width > 1024 ? 48 : 29;

    if (mounted) {
      setLeftArrowHidden(parseInt(navListStyles.marginLeft, 10) === 0);
      setRightArrowHidden((
        topicTab.current.offsetWidth >= (
          navList.current.offsetWidth + parseInt(navListStyles.marginLeft, 10))));
    }
  };

  const trackScrollingState = () => {
    scrolling = true;
    setTimeout(() => {
      scrolling = false;
    }, 300);
  };

  const scroll = (direction) => {
    switch (direction) {
      case DIRECTIONS.LEFT: {
        let width = 0;

        for (let i = 0; i < navList.current.children.length; i += 1) {
          width += navList.current.children[i].offsetWidth + distanceBetween;

          if (
            -parseInt(navListStyles.marginLeft, 10) - topicTab.current.offsetWidth <= width
          ) {
            width -= navList.current.children[i].offsetWidth + distanceBetween;
            break;
          }
        }

        trackScrollingState();
        setNavListStyles({
          marginLeft: `${-Math.max(width, 36) + 36}px`,
        });
        break;
      }
      case DIRECTIONS.RIGHT: {
        let width = 0;

        for (let i = 0; i < navList.current.children.length; i += 1) {
          width += navList.current.children[i].offsetWidth + distanceBetween;

          if (
            -parseInt(navListStyles.marginLeft, 10) + topicTab.current.offsetWidth <= width
          ) {
            width -= navList.current.children[i].offsetWidth + distanceBetween;
            break;
          }
        }

        trackScrollingState();
        setNavListStyles({
          marginLeft: `${-width + 36}px`,
        });
        break;
      }
      default:
    }
  };

  useEffect(() => {
    setMounted(true);
    window.addEventListener('resize', onResize);
    onResize();
    return () => {
      window.removeEventListener('resize', onResize);
      setMounted(false);
    };
  }, []);

  useEffect(() => {
    onResize();
  }, [navListStyles]);

  useEffect(() => {
    if (navList.current && activeTab) {
      const activeTabIndex = tabs.findIndex((tab) => (
        tab.id === activeTab
      ));
      if (activeTabIndex > -1) {
        const activeTabElement = navList.current.children[activeTabIndex];
        if (
          (activeTabElement.getBoundingClientRect().x + activeTabElement.clientWidth)
          >= ((topicMain.current.clientWidth) - distanceBetween + 3)
          && !scrolling
        ) {
          scroll(DIRECTIONS.RIGHT);
        }
      }
    }
  }, [activeTab]);

  return (
    <div
      className={cx('help_center_tabs_main_holder')}
      ref={topicMain}
    >
      <div
        className={cx('tabs_holder')}
        ref={topicTab}
      >
        <div
          hidden={leftArrowHidden}
          className={cx('arrow_left')}
          onClick={() => scroll(DIRECTIONS.LEFT)}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
        </div>
        <div
          ref={navList}
          className={cx('tabs')}
          style={navListStyles}
        >
          {
            tabs.map(({
              id, title, tabPath, subTabs,
            }) => (
              <Tab
                key={id}
                id={id}
                content={title}
                tabPath={tabPath}
                activeTab={activeTab}
                subTabs={subTabs}
              />
            ))
          }
        </div>
        <div
          hidden={rightArrowHidden}
          className={cx('arrow_right')}
          onClick={() => scroll(DIRECTIONS.RIGHT)}
        >
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </div>
    </div>
  );
};

const Tab = ({
  id, content, activeTab, tabPath, subTabs,
}) => {
  const firstSubTabPath = subTabs[0].subTabPath;
  const tabClass = cx('tab', { active: activeTab === id });

  return (
    <div className={tabClass}>
      <Link to={`/help-videos/${tabPath}/${firstSubTabPath}/desktop`} className={cx('tab_title')}>
        {content}
      </Link>
    </div>
  );
};

export default memo(HelpCenterTabs);
